export default __webpack_public_path__ + "static/media/skip-activity-icon.95e5911a.svg";